import { reactive } from 'vue';

/**
 * Shared reactive state for communicating swipe-between-tabs progress
 * from App.vue (touch handler) → SidebarComponent.vue (nav indicator).
 *
 * progress: 0 = still at fromIndex, 1 = fully at toIndex.
 */
export const swipeNavState = reactive({
  active: false,
  fromIndex: -1,
  toIndex: -1,
  progress: 0,
  /** Which tab index should visually look "active" (blue text, scale).
   *  -1 means no override — use the default router-link-exact-active. */
  dominantIndex: -1,
  /** When true, the indicator should render with transition:none for one frame
   *  to prevent the CSS transition from animating a jump after drag cleanup. */
  noTransition: false,
  /** True while a multi-step tap-slide is chaining through intermediate tabs.
   *  Pages can check this to skip expensive work during fly-through. */
  tapSlideChaining: false,
  /** Disable document-level tab swipe gestures while modal-like UI is open. */
  disabled: false
});
